import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateInspectionServicePaymentMethods } from '../../api/inspection-service.ts';
import { UpdateInspectionServicePaymentMethodsRequest } from '../../api/requests/inspection-service-request.ts';

export default function useUpdateInspectionServicePaymentMethods(): UseMutationResult<
  Awaited<ReturnType<typeof updateInspectionServicePaymentMethods>>,
  Error,
  UpdateInspectionServicePaymentMethodsRequest
> {
  return useMutation({
    mutationFn: updateInspectionServicePaymentMethods,
  });
}
